import { useState, useEffect, useContext } from "react"
import buildGeneralViewCollection from "../Dashboarding.functions/buildGeneralViewCollection"
import DatabaseContext from "../../../contexts/Database/DatabaseContext"

const useGeneralViewPage = (periodFilters = {}) => {
  const [data, setData] = useState([])
  const [periods, setPeriods] = useState(null)
  const { dashboardSalesOrders, isLoading: dbLoading } = useContext(DatabaseContext)

  useEffect(() => {
    console.log('🔄 useGeneralViewPage useEffect triggered', {
      dashboardSalesOrders: dashboardSalesOrders?.length,
      dbLoading,
    })

    const loadData = () => {
      try {
        // Don't process if still loading
        if (dbLoading) {
          console.log('⏳ Database still loading, skipping data processing')
          return
        }

        if (!dashboardSalesOrders || dashboardSalesOrders.length === 0) {
          console.log('📭 No dashboard data available')
          setData([])
          return
        }

        console.log('🔧 Starting data transformation...')
        console.log('📅 Period filters:', periodFilters)
        // Transform raw data for General View with period filters
        const result = buildGeneralViewCollection(dashboardSalesOrders, periodFilters)

        console.log(`✅ Loaded ${result.data.length} transformed records for GeneralView`)
        console.log(`📊 Raw records: ${dashboardSalesOrders.length}`)
        console.log('📊 Periods:', result.periods)

        setData(result.data)
        setPeriods(result.periods)
      } catch (error) {
        console.error('❌ Error loading GeneralView data:', error)
        setData([])
      }
    }

    loadData()
  }, [dashboardSalesOrders, dbLoading, periodFilters])

  return {
    data,
    periods,
    isLoading: dbLoading,
  }
}

export default useGeneralViewPage